import { noStoreFetcher } from '@/utils/fetcher'
import useSWRImmutable from 'swr/immutable'
import { API_URL } from '@/utils/constants'
import { collectionObjectApiPath } from '@/utils/collection-object'

export default function useCollectionInscriptions(slug: string, enabled = true) {
	return useSWRImmutable(
		enabled && slug ? `${API_URL}/${collectionObjectApiPath(slug)}/inscriptions` : null,
		noStoreFetcher
	)
}
